<picture>
  <source srcset="/simply-pos.webp" type="image/webp" media="(prefers-color-scheme: light)">
  <source srcset="/simply-pos-dark.webp" type="image/webp" media="(prefers-color-scheme: dark)">
  <img src="/simply-pos.png" alt="Simply POS - Kassensysteme & Bildschirme" class="logo" />
</picture>

<form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
  <mat-card [appearance]="'outlined'">
    <mat-card-header>
      <span matCardTitle>{{customerName() ?? '...'}}</span>
    </mat-card-header>
    <mat-card-content>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'login.emailLabel' | translate }}</mat-label>
        <!-- eslint-disable-next-line @angular-eslint/template/no-autofocus -->
        <input autofocus matInput formControlName="email" type="email"
          [placeholder]="'login.emailPlaceholder' | translate">
        @if (loginForm.get('email')?.hasError('required')) {
        <mat-error>{{ 'login.emailRequiredError' | translate }}</mat-error>
        }
        @if (loginForm.get('email')?.hasError('email')) {
        <mat-error>{{ 'login.emailInvalidError' | translate }}</mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{ 'login.passwordLabel' | translate }}</mat-label>
        <input matInput formControlName="password" type="password"
          [placeholder]="'login.passwordPlaceholder' | translate">
        @if (loginForm.get('password')?.hasError('required')) {
        <mat-error>{{ 'login.passwordRequiredError' | translate }}</mat-error>
        }
      </mat-form-field>

      @if (errorMessage()) {
      <div role="alert">
        <mat-icon>error</mat-icon>
        <p>
          {{ errorMessage()! | translate }}
        </p>
      </div>
      }

    </mat-card-content>
    <mat-card-actions>
      <button mat-flat-button type="submit" [disabled]="loginForm.invalid || isLoading()">{{
        'login.submitButton' | translate
        }}
      </button>

    </mat-card-actions>
  </mat-card>

</form>

<footer sp-footer></footer>